<template>
  <div class="col-12 chartContainer dashboard-item-container">
    <div class="row m-0 justify-content-between dashboard-item-header mb-5">
      <div class="dashboard-item-title">
        Upcoming Appointments
        <sup class="dashboard-selected-time"
          >{{ dateInfo.intervalLabel.start }}-{{
            dateInfo.intervalLabel.end
          }}</sup
        >
      </div>
      <div class="d-flex align-items-center">
        <div
          class="see-all btn see-all-btn btn-prev"
          :class="`${
            loading || dateInfo.index <= 0 ? 'disabled' : 'pointer-cursor'
          }`"
          @click="!loading && dateInfo.index > 0 && getApts(-1)"
        >
          <i class="fas fa-chevron-left"></i>
        </div>
        <div
          class="see-all btn see-all-btn btn-next mr-3"
          :class="`${loading ? 'disabled' : 'pointer-cursor'}`"
          @click="!loading && getApts(1)"
        >
          <i class="fas fa-chevron-right"></i>
        </div>
        <div
          class="see-all pointer-cursor btn see-all-btn"
          @click="navigateToCalender"
        >
          See All <i class="fas fa-chevron-right"></i>
        </div>
        <router-link
          v-if="user && !user.isPatient"
          :to="{ path: '/calendar', query: { create: 1 } }"
          class="add-appointment-btn ml-3"
          v-tooltip.top="'Schedule Appointment'"
          aria-label="Schedule Appointment"
        >
          <i class="fas fa-plus"></i>
        </router-link>
      </div>
    </div>
    <div class="d-flex appointments-semi-calendar">
      <div v-if="loading" class="apt-loader pt-5 mt-5">
        <alert class="mt-5 apt-alert" :emptySlot="true" />
      </div>
      <div
        v-for="label in dateInfo.labels"
        :key="label"
        class="event-outer-container"
      >
        <div class="title">
          {{
            new Date(label).toLocaleDateString("en-US", {
              month: "long",
              day: "numeric",
            })
          }}
        </div>
        <div class="event-container" v-if="events[label] && events[label][0]">
          <div class="event-time">
            {{ formattedDate(events[label][0].start_time) }} –
            {{ formattedDate(events[label][0].end_time) }}
          </div>
          <div
            class="client-name one-line"
            :title="getPatientName(events[label][0])"
          >
            <i
              v-if="events[label][0].is_group_session"
              class="fas fa-users mr-1"
              title="Group session"
            ></i>
            {{ getPatientName(events[label][0]) }}
          </div>
          <div
            class="provider-name one-line"
            :title="getProviderName(events[label][0])"
          >
            {{ getProviderName(events[label][0]) }}
          </div>
          <div class="d-flex justify-content-between align-items-center mt-2">
            <span
              class="event-type"
              :class="
                isVirtual(events[label][0])
                  ? 'event-type--virtual'
                  : 'event-type--in-person'
              "
              >{{ sessionTypeLabel(events[label][0]) }}</span
            >
            <button
              v-if="
                isVirtual(events[label][0]) &&
                (events[label][0].start_url || events[label][0].join_url)
              "
              class="btn btn-sm join-meeting-btn-day"
              @click.stop="joinVirtualMeeting(events[label][0].id)"
              title="Join Virtual Meeting"
            >
              <i class="fas fa-video mr-1"></i>Join
            </button>
          </div>
        </div>
        <div class="no-events" v-else-if="!loading">No appointments</div>
        <div
          class="more-events-container radius-99 pointer-cursor"
          @click="navigateToCalender"
          v-if="events[label] && events[label].length > 1"
        >
          <strong>+{{ events[label].length - 1 }}</strong> more events
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dateFormat from "@/utils/dateFormat";
import * as dayjs from "dayjs";
import { orderBy } from "lodash";
import Swal from "sweetalert2";
import { mapState } from "vuex";

export default {
  name: "dashboard-appointments",
  props: ["maxItems"],
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  created() {
    this.getApts();
  },
  methods: {
    getApts: function (stepDirection = 0) {
      this.dateInfo.index += stepDirection;
      this.loading = true;
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      this.events = [];
      var requestUrl = `users/${this.user.id}/appointments`;
      if (!stepDirection) {
        let startDateTime = `${dateFormat(
          new Date(),
          "YYYY-MM-DD"
        )}T00:00:00.000000Z`;

        let EndDateTime = `${dateFormat(
          new Date(),
          "YYYY-MM-DD"
        )}T23:59:59.000000Z`;
        const canadaOffsetStart = dayjs
          .tz(new Date(startDateTime), "America/Toronto")
          .utcOffset();

        this.dateInfo.start = dayjs(startDateTime)
          .add(canadaOffsetStart, "minute")
          .utc();

        this.dateInfo.end = dayjs(EndDateTime)
          .add(canadaOffsetStart, "minute")
          .add(4, "day")
          .utc();
      } else {
        this.dateInfo.start = this.dateInfo.start.add(stepDirection * 5, "day");
        this.dateInfo.end = this.dateInfo.end.add(stepDirection * 5, "day");
      }

      const labels = [];

      const canadaOffsetStart = dayjs
        .tz(new Date(this.dateInfo.start), "America/Toronto")
        .utcOffset();
      const canadaOffsetEnd = dayjs
        .tz(new Date(this.dateInfo.end), "America/Toronto")
        .utcOffset();
      const localStartDate = new Date(
        this.dateInfo.start
          .add(-canadaOffsetStart, "minute")
          .add(-1 * dayjs(this.dateInfo.start).utcOffset(), "minute")
      );
      const localEndDate = new Date(
        this.dateInfo.end
          .add(-1, "day")
          .add(-canadaOffsetEnd, "minute")
          .add(-1 * dayjs(this.dateInfo.end).utcOffset(), "minute")
      );
      const isSameMonth = localStartDate.getMonth() == localEndDate.getMonth();

      this.dateInfo.intervalLabel = {
        start: `${
          monthNames[localStartDate.getMonth()]
        } ${localStartDate.getDate()}`,
        end: `${
          isSameMonth ? "" : monthNames[localEndDate.getMonth()] + " "
        }${localEndDate.getDate()}`,
      };

      for (let i = 0; i < 5; i++) {
        const labelName = new Date(
          dayjs(this.dateInfo.start)
            .add(-canadaOffsetStart, "minute")
            .add(i, "day")
            .add(-1 * dayjs(this.dateInfo.start).utcOffset(), "minute")
        )
          .toISOString()
          .split("T")[0]; // Extracts the date part

        labels.push(labelName);
      }
      this.dateInfo.labels = labels;

      requestUrl = `${requestUrl}?start=${this.dateInfo.start.format()}&end=${this.dateInfo.end.format()}`;
      if (this.maxItems) {
        requestUrl = `${requestUrl}&size=${this.maxItems}`;
      }
      const appointmentsPromise = this.$http.get(requestUrl);
      let gsUrl = `group-sessions-calendar?start=${this.dateInfo.start.format()}&end=${this.dateInfo.end.format()}`;
      if (
        this.user.isAdmin ||
        this.user.isManagingAdmin ||
        this.user.isProvider
      ) {
        gsUrl += `&provider_user_id=${this.user.id}`;
      } else {
        gsUrl += `&client_id=${this.user.id}`;
      }
      const groupSessionsPromise = this.$http
        .get(gsUrl)
        .then((res) => res.data?.data || []);

      Promise.all([appointmentsPromise, groupSessionsPromise])
        .then(
          function ([appointmentsRes, groupSessions]) {
            this.events = [];
            const appointments =
              appointmentsRes && appointmentsRes.data.data
                ? appointmentsRes.data.data
                : [];

            const mappedGroupSessions = groupSessions.map((gs) => ({
              id: `gs-${gs.id}`,
              is_group_session: true,
              start_time: gs.start,
              end_time: gs.end,
              patient_name: gs.title,
              provider_name: gs.providers,
              patient_id: null,
              provider_id: null,
              type: gs.session_type,
              start_url: gs.virtual_url,
              join_url: gs.virtual_url,
              status: gs.status,
            }));

            const allEvents = [...appointments, ...mappedGroupSessions];
            const futureEvents = allEvents.filter((event) =>
              this.displayPerUserType(event)
            );
            this.events = this.groupEvents(
              orderBy(futureEvents, ["start_time"], ["asc"])
            );
            this.loading = false;
          }.bind(this)
        )
        .catch((err) => {
          if (!err.accessDenied) {
            Swal.fire({
              title: "Error",
              text: (err.data || {}).message || "Something went wrong...",
              icon: "error",
            });
          }
          this.loading = false;
        });
    },
    dateFormat: dateFormat,
    getPatientName: function (task) {
      return task.patient_name;
    },
    getProviderName: function (task) {
      return task.provider_name;
    },
    isVirtual: function (event) {
      return (event.type || "").toUpperCase() === "VIRTUAL";
    },
    // VIRTUAL -> "Virtual", IN_PERSON / IN-PERSON -> "In-Person".
    sessionTypeLabel: function (event) {
      if (this.isVirtual(event)) {
        return "Virtual";
      }
      const type = (event.type || "").replace(/_/g, "-").toLowerCase();
      if (!type || type === "in-person" || type === "inperson") {
        return "In-Person";
      }
      return type.replace(
        /(^|-)([a-z])/g,
        (m, sep, c) => sep + c.toUpperCase()
      );
    },
    formattedDate: function (dateToformat) {
      if (dateToformat && dateToformat != "") {
        return dayjs(dateToformat)
          .add(-1 * dayjs(dateToformat).utcOffset(), "minute")
          .format("hh:mm A");
      } else return "";
    },
    displayPerUserType: function (event) {
      if (event.is_group_session) return true; // Already filtered by backend
      if (this.user.isAdmin || this.user.isManagingAdmin) {
        return true;
      } else if (this.user.isProvider) {
        return event.provider_id == this.user.id;
      } else {
        return event.patient_id == this.user.id;
      }
    },
    navigateToCalender: function () {
      if (this.user.isAdmin || this.user.isManagingAdmin) {
        this.$router.push({ path: "/admin/profile", query: { event: true } });
      } else if (this.user.isProvider) {
        this.$router.push({
          path: `/providers/${this.user.provider_id}`,
          query: { event: true },
        });
      } else {
        this.$router.push({
          path: `/clients/${this.user.patient_id}`,
          query: { event: true },
        });
      }
    },
    groupEvents: function (events) {
      return events.reduce((acc, current) => {
        const canadaOffsetStart = dayjs
          .tz(new Date(current.start_time), "America/Toronto")
          .utcOffset();
        const date = new Date(
          dayjs(current.start_time)
            .add(-canadaOffsetStart, "minute")
            .add(-1 * dayjs(current.start_time).utcOffset(), "minute")
        )
          .toISOString()
          .split("T")[0]; // Extracts the date part
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(current);
        return acc;
      }, {});
    },
    joinVirtualMeeting: function (eventId) {
      let event = null;
      for (let date in this.events) {
        event = this.events[date].find((e) => e.id === eventId);
        if (event) break;
      }
      if (!event) {
        console.error("Event not found");
        return;
      }

      const meetingUrl = event.start_url || event.join_url;
      if (meetingUrl) {
        window.open(meetingUrl, "_blank");
      } else {
        Swal.fire({
          title: "No Meeting URL",
          text: "This virtual session doesn't have a meeting link available.",
          icon: "warning",
        });
      }
    },
  },
  data() {
    return {
      loading: true,
      dateInfo: {
        index: 0,
        start: null,
        end: null,
        labels: [],
        intervalLabel: {
          start: "",
          end: "",
        },
      },
      events: [],
    };
  },
};
</script>

<style lang="scss" scoped>
$card-border: #e6e9ee;

.btn-prev {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right-color: $card-border;
}

.btn-next {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-left-color: $card-border;
}

.add-appointment-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: var(--theme-color);
  color: var(--btn-text-color);
  box-shadow: 0 4px 12px rgba(16, 24, 40, 0.18);
  transition: transform 0.15s;

  &:hover {
    color: var(--btn-text-color);
    transform: scale(1.06);
    text-decoration: none;
  }
}

.appointments-semi-calendar {
  overflow: auto;
}

.event-outer-container {
  border-left: 1px solid $card-border;
  flex: 0 0 20%;
  max-width: 20%;
  padding: 0 12px;
  min-height: 170px;
  min-width: 200px;

  &:first-of-type {
    border-left: 0;
    padding-left: 0;
  }

  .title {
    color: var(--main-text-color);
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 14px;
  }

  .event-container {
    background-color: #ffffff;
    border: 1px solid $card-border;
    border-radius: 14px;
    padding: 14px 16px;
    width: 100%;
    box-shadow: 0 4px 14px rgba(16, 24, 40, 0.06);
  }

  .event-time {
    font-size: 14px;
    font-weight: 600;
    color: #1f2328;
    margin-bottom: 6px;
  }

  .client-name {
    color: var(--main-text-color);
    font-weight: 600;
    font-size: 16px;
  }

  .provider-name {
    font-size: 14px;
    margin-top: 2px;
    color: #343a40;
  }

  .event-type {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 99px;
    font-size: 12px;
    font-weight: 600;

    &--virtual {
      background-color: rgba(44, 123, 229, 0.12);
      color: #1d5fb8;
    }
    &--in-person {
      background-color: rgba(3, 142, 84, 0.12);
      color: #037446;
    }
  }

  .join-meeting-btn-day {
    padding: 2px 10px;
    font-size: 12px;
    border-radius: 99px;
    background-color: var(--theme-color);
    color: var(--btn-text-color);
  }

  .no-events {
    font-size: 14px;
    color: #343a40;
    padding: 12px 0;
  }

  .more-events-container {
    padding: 6px 12px;
    background-color: #ffffff;
    border: 1px solid $card-border;
    margin-top: 12px;
    margin-bottom: 8px;
    color: var(--main-text-color);
    font-size: 14px;
    width: 100%;
    word-break: break-word;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f6f8fa;
    }
  }
}
</style>

<style lang="scss">
.apt-loader {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .apt-alert {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 12px;

    .spinner-border {
      width: 64px;
      height: 64px;
    }
  }
}
</style>
